import { RenderUnsettledUI, SmallError, SmallLoader } from 'shared/components';
import { useHqGetShiftDetailsTabs } from 'shared/components/shift-detail-modal/hooks/hq/use-hq-get-shift-detail-tabs';
import { useHqGetShift } from 'shared/components/shift-forms/hooks/hq/use-hq-get-shift';
import { Box, Divider } from '@mui/material';
import { ModalPanelBody } from 'redesign';
import { ShiftDetailHead } from 'shared/components/shift-detail-modal/components/shift-detail-head/shift-detail-head';
import { ShiftDetail } from 'api/services/shift/schema/shift-detail.schema';
import { useSiteDetection } from 'shared/hooks';
import {
  ShiftActionCallback,
  useGetShiftDetailHeadActions,
} from '../hooks/use-get-shift-detail-head-actions';

export const ShiftPlanningModalProvider = ({
  closeShiftDetail,
  onDelete,
  shiftDetailId,
  setShiftAction,
}: {
  closeShiftDetail: () => void;
  onDelete: () => void;
  shiftDetailId: string | null;
  setShiftAction: ShiftActionCallback;
}) => {
  const siteDetectionResult = useSiteDetection();
  const shiftQuery = useHqGetShift(siteDetectionResult.site, shiftDetailId);

  if (!shiftDetailId) {
    return <></>;
  }

  if (shiftQuery.status !== 'success') {
    return (
      <RenderUnsettledUI
        renderLoading={<SmallLoader />}
        renderError={(error) => <SmallError error={error} />}
        data={shiftQuery}
      />
    );
  }

  return (
    <ShiftPlanningModal
      closeShiftDetail={closeShiftDetail}
      onDelete={onDelete}
      data={shiftQuery.data}
      setShiftAction={setShiftAction}
    />
  );
};

const ShiftPlanningModal = ({
  data,
  onDelete,
  closeShiftDetail,
  setShiftAction,
}: {
  data: ShiftDetail;
  closeShiftDetail: () => void;
  onDelete: () => void;
  setShiftAction: ShiftActionCallback;
}) => {
  const shiftDetailTabs = useHqGetShiftDetailsTabs(data);
  const { children, isArchiving } = useGetShiftDetailHeadActions({
    data: data,
    closeModal: closeShiftDetail,
    onDelete,
    setShiftAction,
  });

  return (
    <Box p={8} height="100%" display="flex" flexDirection="column">
      <ShiftDetailHead
        data={data}
        close={closeShiftDetail}
        actions={children}
        isArchiving={isArchiving}
        showTempWorkRate={true}
      />
      <Box mt={8} mb={8}>
        <Divider />
      </Box>
      <ModalPanelBody tabs={shiftDetailTabs} />
    </Box>
  );
};
